import React, { Component } from "react";
import ProductsNewCustom from "./ProductsNewCustom";
import * as util from "../../utils/util";
import "../../components/onboarding/SelectBubble.css";
import "./ProductsNew.css";
import Responsive from 'react-responsive';


import { MultComponentButton } from "./OnboardingStyles";
import { answerBubbleStyle, answerBubbleStyleMobile } from "../../utils/styles";

class ProductsNew extends Component {
  constructor(props) {
    super(props);

    this.handleDone = this.handleDone.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);

    this.products = [];
    this.productIndices = [];
    this.productsStr = "";

    this.state = {
      customed: null,
      finished: false,
      showText: this.props.showText,
    };
  }

  componentDidMount(){
    
    util.arrayRemoveObj();

    let doneButton = document.querySelector(".productsNewConten");
    if (doneButton) doneButton.scrollIntoView();

     // 进度条
     try {
      if(this.props.fun_updateStage){
        var stage = this.props.stage;
        var stageSum = this.props.stageSum;
        if(stage && stageSum)
        this.props.fun_updateStage(parseInt(stage)-1,stageSum);
      }
    } catch (error) {
      console.error(error);
    }

  }

  componentDidUpdate() {
    let doneButton = document.querySelector(".productsNewConten");
    if (doneButton) doneButton.scrollIntoView();
  }

  handleOnClick(id) {
    this.setState({ selected: id });
    if (id === 1) {
      this.products = [];
      this.productIndices = [];
      this.addItem({ index: 13, value: "3-Step Regimen" });
    } else if (id === 2) {
      this.products = [];
      this.productIndices = [];
      this.addItem({ index: 14, value: "5-Step Regimen" });
    } else if (id === 3) {
    
      this.products.remove('Ava recommended routine');
      this.productIndices.remove(10);

      this.products.remove('I’m not sure');
      this.productIndices.remove(16);


      let indexThreeStep = this.products.indexOf("3-Step Regimen");
      let indexThreeStepIndices = this.productIndices.indexOf(13);
      let indexFiveStep = this.products.indexOf("5-Step Regimen");
      let indexFiveStepIndices = this.productIndices.indexOf(14);
      if (indexThreeStep > -1 || indexThreeStepIndices > -1) {
        this.products.splice(indexThreeStep, 1);
        this.productIndices.splice(indexThreeStepIndices, 1);
      } else if (indexFiveStep > -1 || indexFiveStepIndices > -1) {
        this.products.splice(indexFiveStep, 1);
        this.productIndices.splice(indexFiveStepIndices, 1);
      }
    }else if (id === 16) {
      this.products = [];
      this.productIndices = [];
      this.addItem({ index: 16, value: "Ava recommended routine" });
    }else if(id === 10){
      this.products = [];
      this.productIndices = [];
      this.addItem({ index: 10, value: "I’m not sure" });
    }

  }

  addItem(answer) {
    let index = this.products.indexOf(answer.value);
    if (index === -1) {
      this.products.push(answer.value);
    }
    index = this.productIndices.indexOf(answer.index);
    if (index === -1) {
      this.productIndices.push(answer.index);
    }
  }

  removeItem(answer) {
    let index = this.products.indexOf(answer.value);
    if (index > -1) {
      this.products.splice(index, 1);
    }
    index = this.productIndices.indexOf(answer.index);
    if (index > -1) {
      this.productIndices.splice(index, 1);
    }
  }

  handleDone() {

    if(this.state.selected === 3 && this.products.length <= 0){
      alert("Please select an answer.");
      return false;
    }else{
        if (this.state.selected > 0 ) {
          this.setState({ finished: true });
          
          try {
            let step = this.props.step;
            localStorage.setItem("doneQuizStepId",step.id);
          } catch (error) {
            console.error(error);
          }

          try {
            if(this.props.fun_updateStage){
              var stage = this.props.stage;
              var stageSum = this.props.stageSum;
              if(stage && stageSum)
              this.props.fun_updateStage(stage,stageSum);
            }
          } catch (error) {
            console.error(error);
          }
    
          if (this.state.selected === 1 || this.state.selected === 2 || this.state.selected === 16 || this.state.selected === 10) {
            this.productsStr = this.products[0];
            localStorage.setItem("SQ_productsNew", this.productIndices[0]);
            this.props.step.value = { value: this.productIndices[0], label:  this.productsStr};
            this.props.triggerNextStep({ value: { value: this.productIndices[0], label:  this.productsStr}  });
            
    
          } else if (this.state.selected === 3) {
            this.productsStr = this.products.join(", ");
            this.props.triggerNextStep({ value: {value: this.productIndices.join(", "), label: this.productsStr  } });
    
            localStorage.setItem("SQ_productsNew", this.productIndices.join(", "));
          }
        }else{
          alert("Please select an answer.");
        }
    }
    
  }

  fun_ownSelectAll() {
    this.productIndices = [1, 2, 3, 4, 5, 6, 7, 8, 11, 12];
    this.products = ["Cleanser", "Toner", "Moisturizer", "SPF", "Serum", "Eye Cream", "Exfoliator", "Mask", "Makeup Remover", "Treatment"];
}

  renderProducts() {
    const touchsupport = util.isMobile(navigator.userAgent);
    return (

      <div
        className={
          !touchsupport
            ? "container quiz-products"
            : "container quiz-products nohover"
        }
      >


        <div
          className={
            this.state.selected === 16
              ? "quiz-products-section five-step selected"
              : "quiz-products-section five-step"
          }
          onClick={() => this.handleOnClick(16)}
        >
          <div className="title">Ava recommended routine</div>
          
          <div className="incl-products">
            Cleanser, Exfoliator, Toner, Moisturizer, SPF
          </div>
        </div>

        <div
            className={
              this.state.selected === 3
                ? "quiz-products-section custom selected"
                : "quiz-products-section custom"
            }
            onClick={() => this.handleOnClick(3)}
          >
            <div className="title" style={{marginTop:'12px'}}>Create your own</div>
            
            <ProductsNewCustom
              addItem={this.addItem}
              removeItem={this.removeItem}
              notSelected={this.state.selected !== 3}
              products={this.products}
              productIndices={this.productIndices}
            />
            <div className="own-button-selectAll" onClick={()=>{ this.fun_ownSelectAll() }}>Select all</div>
        </div>

        <div className={this.state.selected === 10 ? "quiz-products-section five-step selected" : "quiz-products-section five-step"} onClick={ ()=> this.handleOnClick(10) }  ><div className="title">I’m not sure</div></div>

        <button className="p-a-n-button submit-but" onClick={this.handleDone}>Continue</button>
     
            {/* this.state.selected === 1 ||
            this.state.selected === 2 ||
            (this.state.selected === 3 && this.products.length > 0 */}

      </div>
    );
  }

  render() {
    if (this.state.finished) {
      return (
        <div className="onb-item-container">
          <div className="onb-text-conten">
              {this.state.showText}
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ margin: "1px auto" }} className={this.state.finished ? "rsc-ts sc-dnqmqq" : null}>
            <div className="onb-item-container productsNewConten">
                <div className="onb-text-conten">
                    {this.state.showText}
                </div>
                {this.renderProducts()}

            </div>
        </div>
      );
    }
  }
}

export default ProductsNew;



// WEBPACK FOOTER //
// ./src/views/onboarding/ProductsNew.js